<template>
    <div class="overflow-y-auto font-oceanside">
        <div
            v-for="(group, i) in initialGroups"
            :key="group.id" class="py-4"
        >
            <summary-details-item :group="group" :index="i" />
        </div>

        <div v-if="synthesizedFrontGroup" class="py-4">
            <summary-details-item :group="synthesizedFrontGroup" :index="0" />
        </div>

        <div
            v-for="(group, i) in remainingGroups"
            :key="group.id" class="py-4"
        >
            <summary-details-item :group="group" :index="i" />
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import SummaryDetailsItem from './SummaryDetailsItem.vue';

    export default {
        mixins: [allStores],

        components: {
            SummaryDetailsItem,
        },

        computed: {
            visibleGroups() {
                return this.customizerStore.buildVisibleGroups({
                    sourceGroups: this.customizerStore.visibleGroups,
                });
            },
            synthesizedFrontGroup() {
                const frontGroup = this.visibleGroups
                    .find((group) => this.isFaceSoleGroup(group));
                const subgroups = this.customizerStore.visibleGroups
                    .filter((group) => this.isFaceSoleSummaryGroup(group));

                if (!frontGroup || subgroups.length === 0) {
                    return null;
                }

                return {
                    ...frontGroup,
                    subgroups,
                };
            },
            initialGroups() {
                return this.visibleGroups
                    .filter(
                        (group) => !this.isFaceSoleGroup(group)
                            && group.code !== 'TopPaintfill'
                            && group.code !== 'BackPaintfill'
                            && group.code !== 'PutterShaftBand'
                            && group.code !== 'Headcover'
                            && group.code !== 'Grip',
                    );
            },
            remainingGroups() {
                return this.visibleGroups
                    .filter((group) => !this.isFaceSoleGroup(group) && !this.initialGroups.includes(group))
                    .sort((a, b) => {
                        // manually sort the groups
                        const order = [
                            'BackPaintfill',
                            'TopPaintfill',
                            'Grip',
                            'Headcover',
                            'PutterShaftBand',
                        ];
                        return order.indexOf(a.code) - order.indexOf(b.code);
                    });
            },
            productPriceCurrent() {
                return this.customizerStore.currentPriceFormatted?.current;
            },
            isPrintMode() {
                return this.appStore.isPrintMode;
            },

            hasOpenNestedPanel() {
                return this.appStore.hasOpenNestedPanel;
            },
        },

        methods: {
            isFaceSoleGroup(group) {
                return group?.name === 'Face/Sole' || group?.code === 'Face/Sole';
            },
            isFaceSoleSummaryGroup(group) {
                return ['CharacterStamping', 'Stamps', 'Paintfill'].includes(group.code);
            },
            setSelectedGroup(itemData) {
                this.customizerStore.setCurrentGroup(itemData.name);
            },
            setShowGroupOverlay(value) {
                this.appStore.setShowGroupOverlay(value);
            },
            setShouldShowSummary(value) {
                this.appStore.setShouldShowSummary(value);
            },
            async handleRedirectToPanel(placement) {
                this.setShowGroupOverlay(false);
                await new Promise((resolve) => { setTimeout(resolve, 250); });
                this.setSelectedGroup(placement);
                this.setShouldShowSummary(false);
                this.setShowGroupOverlay(true);
            },
            getGroupTitleFromCode(code) {
                switch (code) {
                case 'CharacterStamping':
                    return this.$t('CATEGORY_CHARACTER_STAMPING');
                case 'Stamps':
                    return this.$t('CATEGORY_TOE_ENGRAVING');
                case 'ShaftBand':
                    return this.$t('CATEGORY_SHAFT_BAND');
                case 'Paintfill':
                    return this.$t('CATEGORY_PAINTFILL');
                case 'TopPaintfill':
                    return this.$t('CATEGORY_TOP_PAINTFILL');
                case 'BackPaintfill':
                    return this.$t('CATEGORY_BACK_PAINTFILL');
                default:
                    return this.$te(`CATEGORY_CODE_${code}`) ? this.$t(`CATEGORY_CODE_${code}`) : code;
                }
            },
            getDescriptionText(description) {
                let text = '';

                description.forEach((desc) => {
                    text += ` ${desc.name}`;
                });

                return text.trim();
            },
        },
    };
</script>
